export const paths = {
  MainPage: "/",
  AboutUsPage: "about-us",
  ContactsPage: "contacts",
  TenderhubPage: "tenderhub",
  CasesPage: "cases",
  ServicesPage: "services",
  ServicesEventMarketingPage: "services/event-marketing",
  ServicesSportMarketingPage: "services/sport-marketing",
  ServicesConsumerPromoPage: "services/consumer-promotion",
  CasePage: "cases/:caseId",
  NotFoundPage: "not-found",
  SelfEmployedFormPage: "regsmz",
  CaseYogaDayPage: "cases/yoga-day",
  ShowreelPage: "showreel",
};
